document.addEventListener("DOMContentLoaded", function () {

  // All sliders
  window.SplideSliderFunction = function () {

    document.querySelectorAll('.splide').forEach((element) => {

      const perPage = parseInt(element.dataset.perPage) || 1;
      const gap = element.dataset.gap || '24px';
      const drag = element.dataset.drag === 'true';
      const arrows = element.dataset.arrows === 'true';
      const autoplay = element.dataset.autoplay === 'true';
      const autoplayintervel = parseInt(element.dataset.autoplayintervel) || 3000;
      const type = element.dataset.type || 'slide';
      const paginatione = element.dataset.pagination === 'true';

      // Padding
      const paddingLeft = element.dataset.paddingLeft
        ? element.dataset.paddingLeft + 'px'
        : 0;

      const paddingRight = element.dataset.paddingRight
        ? element.dataset.paddingRight + 'px'
        : 0;

      // Breakpoints
      let breakpoints = {};

      if (element.dataset.breakpoints) {
        try {
          breakpoints = JSON.parse(element.dataset.breakpoints);
        } catch (e) {
          console.warn('Invalid breakpoints JSON:', element.dataset.breakpoints);
        }
      }

      // Splide Init
      const splide = new Splide(element, {
        type: type,
        perPage: perPage,
        arrows: arrows,
        pagination: paginatione,
        drag: drag,
        autoplay: autoplay,
        gap: gap,
        interval: autoplayintervel,

        padding: {
          left: paddingLeft,
          right: paddingRight,
        },

        breakpoints: breakpoints,
      });

      // Custom Arrows
      const prevBtn = element.querySelector('.splide-custom-prev');
      const nextBtn = element.querySelector('.splide-custom-next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          splide.go('<');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          splide.go('>');
        });
      }

      // Arrow Disable Logic
      const updateArrowState = () => {

        if (type === 'loop') return;

        const index = splide.index;
        const end = splide.Components.Controller.getEnd();

        if (prevBtn) {
          prevBtn.classList.toggle('is-disabled', index === 0);
        }

        if (nextBtn) {
          nextBtn.classList.toggle('is-disabled', index >= end);
        }
      };

      splide.on('mounted move', updateArrowState);

      // Progress Bar
      const bar = element.querySelector('.my-carousel-progress-bar');

      if (bar) {

        const updateProgress = () => {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = ((splide.index + 1) / end) * 100;

          bar.style.width = rate + '%';
        };

        splide.on('mounted move', updateProgress);
      }

      // Mount
      splide.mount();

    });

  };

  // Init All Sliders
  SplideSliderFunction();

});